import { render, staticRenderFns } from "./platbody-info.vue?vue&type=template&id=b820e582&"
import script from "./platbody-info.vue?vue&type=script&lang=js&"
export * from "./platbody-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports